import { render, staticRenderFns } from "./decoration_homepage.vue?vue&type=template&id=b6929610&scoped=true&"
import script from "./decoration_homepage.vue?vue&type=script&lang=js&"
export * from "./decoration_homepage.vue?vue&type=script&lang=js&"
import style0 from "./decoration_homepage.vue?vue&type=style&index=0&id=b6929610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6929610",
  null
  
)

export default component.exports